import React from 'react';
import { Checkbox } from '@naf-simba/elements-checkbox';
import { TextVariant } from '@naf/text';
import xor from 'lodash/xor';
import S from '../Styles';

export interface FilterItem {
  value: string;
  label: string;
  count: number;
}

interface FilterGroupProps {
  header: string;
  items: FilterItem[];
  selected: string[];
  onChange: (next: string[]) => void;
}

const FilterGroup = ({ header, items, selected, onChange }: FilterGroupProps) => (
  <S.Filter>
    <S.FilterHeader variant={TextVariant.BodyTextHeader}>{header}</S.FilterHeader>
    <Checkbox name={`${header}-alle`} checked={selected.length === 0} onChange={() => onChange([])} label="Alle" />
    {items.map(({ value, label, count }) => (
      <Checkbox
        key={value}
        name={value}
        checked={selected.includes(value)}
        disabled={count === 0}
        onChange={() => onChange(xor(selected, [value]))}
        label={`${label} (${count})`}
      />
    ))}
  </S.Filter>
);

export default FilterGroup;
